module.exports = __webpack_public_path__ + "static/media/number-two.cec008f4.svg";